const React = require('react');
const { useState } = React;
const { useNavigate } = require('react-router-dom');
const api = require('../api/axios').default || require('../api/axios');

const STEPS = [
  'Welcome',
  'Profile',
  'Competencies',
  'Education',
  'Social Proof',
  'Payout Details',
  'Verification'
];

const COMPETENCY_OPTIONS = [
  'Vedic Astrology',
  'Numerology',
  'Palmistry',
  'Tarot Reading',
  'Vastu Shastra',
  'Gemology'
];

const LANGUAGE_OPTIONS = [
  'Hindi',
  'Tamil',
  'English',
  'Bengali',
  'Telugu',
  'Marathi',
  'Gujarati',
  'Kannada'
];

const AcaryaRegister = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    displayName: '',
    email: '',
    password: '',
    image: '',
    bio: '',
    languagesSpoken: [],
    coreCompetencies: [],
    yearsExperience: '',
    qualifications: '',
    certificationsUrl: '',
    youtube: '',
    website: '',
    social: '',
    pan: '',
    bankAccount: '',
    ifsc: '',
    sampleReadingUrl: ''
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const showToast = (type, text) => {
    setToast({ type, text });
    setTimeout(() => setToast(null), 5000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxToggle = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].includes(value)
        ? prev[field].filter(item => item !== value)
        : [...prev[field], value]
    }));
  };

  const handleNext = (e) => {
    if (e) e.preventDefault();
    setStep(s => s + 1);
  };
  
  const handleBack = () => setStep(s => s - 1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        name: formData.name,
        displayName: formData.displayName,
        email: formData.email,
        password: formData.password,
        image: formData.image || 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=200&h=200&auto=format&fit=crop',
        bio: formData.bio,
        languagesSpoken: formData.languagesSpoken,
        coreCompetencies: formData.coreCompetencies,
        experienceEducation: {
          yearsExperience: parseInt(formData.yearsExperience) || 0,
          qualifications: formData.qualifications,
          certificationsUrl: formData.certificationsUrl || ''
        },
        socialProof: {
          youtube: formData.youtube,
          website: formData.website,
          social: formData.social
        },
        payoutInfo: {
          pan: formData.pan,
          bankAccount: formData.bankAccount,
          ifsc: formData.ifsc
        },
        sampleReadingUrl: formData.sampleReadingUrl
      };

      const res = await api.post('/acaryas/requests', payload);
      if (res.data.success) {
        showToast('success', '🙏 Application submitted successfully! Our acarya panel will contact you for your 10-minute video interview.');
        setTimeout(() => navigate('/login'), 4000);
      } else {
        showToast('error', res.data.message || 'Failed to submit application.');
      }
    } catch (err) {
      showToast('error', err.response?.data?.message || 'Error occurred during registration submission.');
    } finally {
      setLoading(false);
    }
  };

  const inp = { width: '100%', padding: '0.75rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '0.5rem', color: '#fff', boxSizing: 'border-box', fontSize: '0.875rem' };
  const lbl = { display: 'block', marginBottom: '0.4rem', color: '#E8B84B', fontSize: '0.8rem', fontWeight: 600 };
  const row = { display: 'flex', gap: '1rem' };
  const col = { flex: 1 };
  const btnBack = { flex: 1, padding: '0.75rem', background: 'transparent', border: '1px solid #444', borderRadius: '0.5rem', color: '#888', cursor: 'pointer', fontWeight: 600 };
  const btnNext = { flex: 2, padding: '0.75rem', background: 'linear-gradient(90deg, #E8B84B, #B8923A)', border: 'none', borderRadius: '0.5rem', color: '#000', fontWeight: 800, cursor: 'pointer' };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
      background: 'radial-gradient(ellipse at 20% 50%, rgba(212,175,55,0.07) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(140,92,246,0.04) 0%, transparent 50%), #0a0a0a',
      padding: '2rem 1rem',
      fontFamily: "'Inter', sans-serif"
    }}>
      <div style={{ width: '100%', maxWidth: '650px' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✨</div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 900, letterSpacing: '0.1em', background: 'linear-gradient(135deg, #E8B84B, #FFD26E, #B8923A)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '0.2rem', fontFamily: "'Playfair Display', serif" }}>Ananda Marga</h1>
          <p style={{ color: '#666', fontSize: '0.7rem', letterSpacing: '0.25em', textTransform: 'uppercase' }}>Acarya Consultant Onboarding</p>
        </div>

        {/* Step Indicator */}
        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1.75rem', overflowX: 'auto', paddingBottom: '0.5rem' }}>
          {STEPS.map((label, idx) => {
            const num = idx + 1;
            const done = step > num;
            const active = step === num;
            return (
              <React.Fragment key={label}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0, minWidth: '70px', flex: 1 }}>
                  <div style={{
                    width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.7rem', fontWeight: 900,
                    background: done ? '#E8B84B' : active ? 'rgba(212,175,55,0.15)' : 'rgba(255,255,255,0.04)',
                    border: `2px solid ${done || active ? '#E8B84B' : '#2a2a2a'}`,
                    color: done ? '#000' : active ? '#E8B84B' : '#444',
                    transition: 'all 0.3s',
                  }}>
                    {done ? '✓' : num}
                  </div>
                  <span style={{ fontSize: '0.55rem', color: active ? '#E8B84B' : done ? '#888' : '#444', marginTop: '0.3rem', textTransform: 'uppercase', letterSpacing: '0.04em', textAlign: 'center', lineHeight: 1.2 }}>{label}</span>
                </div>
                {idx < STEPS.length - 1 && (
                  <div style={{ flex: 1, minWidth: '15px', height: '2px', background: step > num ? '#E8B84B' : '#1e1e1e', marginTop: '13px', transition: 'background 0.3s' }} />
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* Toast */}
        {toast && (
          <div style={{ background: toast.type === 'success' ? 'rgba(34,197,94,0.1)' : 'rgba(248,68,68,0.1)', border: `1px solid ${toast.type === 'success' ? 'rgba(34,197,94,0.3)' : 'rgba(248,68,68,0.3)'}`, borderRadius: '0.5rem', padding: '0.85rem 1rem', color: toast.type === 'success' ? '#4ade80' : '#f87171', marginBottom: '1rem', fontSize: '0.85rem' }}>
            {toast.text}
          </div>
        )}

        <div style={{ padding: '2rem', background: 'rgba(20,18,16,0.95)', border: '1px solid rgba(212,175,55,0.1)', borderRadius: '1.5rem', backdropFilter: 'blur(20px)', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}>

          {/* ─── STEP 1: Landing Page ─── */}
          {step === 1 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <div style={{ textAlign: 'center', padding: '1rem 0' }}>
                <h2 style={{ color: '#fff', fontSize: '1.5rem', fontWeight: 800, marginBottom: '0.5rem', fontFamily: "'Playfair Display', serif" }}>Join as an Acarya Consultant</h2>
                <p style={{ color: '#a0a0a0', fontSize: '0.875rem' }}>Share your wisdom, connect with devotees, and manage your earnings with complete scheduling flexibility.</p>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={{ background: 'rgba(255,255,255,0.02)', padding: '1.25rem', borderRadius: '1rem', border: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>💰</div>
                  <h3 style={{ color: '#E8B84B', fontSize: '0.9rem', fontWeight: 700, marginBottom: '0.25rem' }}>70% Payout Share</h3>
                  <p style={{ color: '#777', fontSize: '0.75rem', margin: 0, lineHeight: 1.4 }}>You keep 70% of all session consultation earnings. The remaining 30% platform fee covers hosting, payment gateways, and outreach.</p>
                </div>
                <div style={{ background: 'rgba(255,255,255,0.02)', padding: '1.25rem', borderRadius: '1rem', border: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🗓️</div>
                  <h3 style={{ color: '#E8B84B', fontSize: '0.9rem', fontWeight: 700, marginBottom: '0.25rem' }}>Scheduling Flexibility</h3>
                  <p style={{ color: '#777', fontSize: '0.75rem', margin: 0, lineHeight: 1.4 }}>Define your own open hours, block days off, and customize rates per minute. Work fully on your own schedule.</p>
                </div>
              </div>

              <div style={{ background: 'rgba(212,175,55,0.05)', padding: '1rem', borderRadius: '0.75rem', border: '1px solid rgba(212,175,55,0.1)' }}>
                <h4 style={{ color: '#E8B84B', fontSize: '0.8rem', fontWeight: 700, margin: '0 0 0.25rem 0' }}>📋 Verification & Interview Process:</h4>
                <p style={{ color: '#a0a0a0', fontSize: '0.75rem', margin: 0, lineHeight: 1.4 }}>
                  To maintain the highest consultancy standard, every applicant undergoes certificate checks and a mandatory 10-minute test interview with our senior acarya panel before dashboard activation.
                </p>
              </div>

              <button type="button" onClick={handleNext} style={{ ...btnNext, padding: '1rem', fontSize: '0.9rem', marginTop: '1rem' }}>
                Begin Application Funnel →
              </button>
            </div>
          )}

          {/* ─── STEP 2: Personal Profile ─── */}
          {step === 2 && (
            <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>Personal Profile</h2>
                <p style={{ color: '#777', fontSize: '0.78rem', marginBottom: '1rem' }}>Set up your identity and credentials shown to clients.</p>
              </div>
              <div>
                <label style={lbl}>Full Name (Real/Government Name) *</label>
                <input name="name" value={formData.name} onChange={handleChange} required placeholder="e.g. Acharya Devendra Shastri" style={inp} />
              </div>
              <div>
                <label style={lbl}>Display Name (Shown on client-facing app) *</label>
                <input name="displayName" value={formData.displayName} onChange={handleChange} required placeholder="e.g. Acarya Devendra" style={inp} />
              </div>
              <div style={row}>
                <div style={col}>
                  <label style={lbl}>Email Address (Login Username) *</label>
                  <input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="e.g. devendra@shastri.com" style={inp} />
                </div>
                <div style={col}>
                  <label style={lbl}>Login Password *</label>
                  <div style={{ position: 'relative' }}>
                    <input 
                      name="password" 
                      type={showPassword ? 'text' : 'password'} 
                      value={formData.password} 
                      onChange={handleChange} 
                      required 
                      placeholder="Minimum 6 characters" 
                      style={{ ...inp, paddingRight: '2.75rem' }} 
                    />
                    <button 
                      type="button" 
                      onClick={() => setShowPassword(v => !v)} 
                      style={{ 
                        position: 'absolute', 
                        right: '0.75rem', 
                        top: '50%', 
                        transform: 'translateY(-50%)', 
                        background: 'none', 
                        border: 'none', 
                        cursor: 'pointer', 
                        color: '#666',
                        fontSize: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0
                      }}
                    >
                      {showPassword ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <label style={lbl}>Profile Photo URL *</label>
                <input name="image" value={formData.image} onChange={handleChange} required placeholder="Paste profile picture URL (or upload below)" style={inp} />
                <p style={{ color: '#555', fontSize: '0.72rem', marginTop: '0.3rem' }}>Use a high-resolution, head-facing picture with clear lighting.</p>
              </div>
              <div>
                <label style={lbl}>Professional Biography (Bio) *</label>
                <textarea name="bio" rows="3" value={formData.bio} onChange={handleChange} required placeholder="Tell clients about your lineage, fields of knowledge, and philosophy..." style={{ ...inp, resize: 'vertical' }} />
              </div>
              <div>
                <label style={lbl}>Languages Spoken (Select all that apply) *</label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginTop: '0.5rem' }}>
                  {LANGUAGE_OPTIONS.map(lang => {
                    const selected = formData.languagesSpoken.includes(lang);
                    return (
                      <div
                        key={lang}
                        onClick={() => handleCheckboxToggle('languagesSpoken', lang)}
                        style={{
                          padding: '0.5rem 0.75rem', borderRadius: '0.35rem', cursor: 'pointer',
                          background: selected ? 'rgba(212,175,55,0.1)' : 'rgba(255,255,255,0.02)',
                          border: `1px solid ${selected ? '#E8B84B' : '#333'}`,
                          color: selected ? '#FFD26E' : '#888',
                          fontSize: '0.75rem', textAlign: 'center', transition: 'all 0.2s'
                        }}
                      >
                        {lang}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.75rem' }}>
                <button type="button" onClick={handleBack} style={btnBack}>← Back</button>
                <button type="submit" style={btnNext}>Next: Core Competencies →</button>
              </div>
            </form>
          )}

          {/* ─── STEP 3: Core Competencies ─── */}
          {step === 3 && (
            <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>Core Competencies</h2>
                <p style={{ color: '#777', fontSize: '0.78rem', marginBottom: '1rem' }}>Select your areas of astrological and consultancy acaryaise.</p>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {COMPETENCY_OPTIONS.map(skill => {
                  const selected = formData.coreCompetencies.includes(skill);
                  return (
                    <div
                      key={skill}
                      onClick={() => handleCheckboxToggle('coreCompetencies', skill)}
                      style={{
                        padding: '0.85rem 1rem', borderRadius: '0.5rem', cursor: 'pointer',
                        border: `1px solid ${selected ? '#E8B84B' : '#333'}`,
                        background: selected ? 'rgba(212,175,55,0.08)' : 'rgba(255,255,255,0.02)',
                        color: selected ? '#FFD26E' : '#888',
                        fontSize: '0.875rem', fontWeight: selected ? 600 : 400,
                        transition: 'all 0.2s', display: 'flex', alignItems: 'center', gap: '0.75rem',
                      }}
                    >
                      <span style={{ fontSize: '1.1rem' }}>{selected ? '✅' : '⬜'}</span>
                      {skill}
                    </div>
                  );
                })}
              </div>
              
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
                <button type="button" onClick={handleBack} style={btnBack}>← Back</button>
                <button type="submit" disabled={formData.coreCompetencies.length === 0} style={{ ...btnNext, opacity: formData.coreCompetencies.length === 0 ? 0.5 : 1 }}>Next: Education & Experience →</button>
              </div>
            </form>
          )}

          {/* ─── STEP 4: Experience & Education ─── */}
          {step === 4 && (
            <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>Experience & Education</h2>
                <p style={{ color: '#777', fontSize: '0.78rem', marginBottom: '1rem' }}>List your credentials and upload your institutional certifications.</p>
              </div>
              <div>
                <label style={lbl}>Years of Experience *</label>
                <input name="yearsExperience" type="number" required value={formData.yearsExperience} onChange={handleChange} placeholder="e.g. 12" style={inp} />
              </div>
              <div>
                <label style={lbl}>Educational Qualifications / Title *</label>
                <input name="qualifications" required value={formData.qualifications} onChange={handleChange} placeholder="e.g. Jyotish Acharya (Bharatiya Vidya Bhavan)" style={inp} />
              </div>
              <div>
                <label style={lbl}>Verification Certificate Link / URL *</label>
                <input name="certificationsUrl" required value={formData.certificationsUrl} onChange={handleChange} placeholder="Paste link to verification certificate PDF or image" style={inp} />
                <p style={{ color: '#555', fontSize: '0.72rem', marginTop: '0.3rem' }}>Upload certificate to Google Drive/Dropbox and paste the link here for verification.</p>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
                <button type="button" onClick={handleBack} style={btnBack}>← Back</button>
                <button type="submit" style={btnNext}>Next: Social Proof →</button>
              </div>
            </form>
          )}

          {/* ─── STEP 5: Social Proof ─── */}
          {step === 5 && (
            <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>Social Proof & Followers (Optional)</h2>
                <p style={{ color: '#777', fontSize: '0.78rem', marginBottom: '1rem' }}>Links to verify your existing following and profile authenticity.</p>
              </div>
              <div>
                <label style={lbl}>YouTube Channel Link</label>
                <input name="youtube" value={formData.youtube} onChange={handleChange} placeholder="e.g. https://youtube.com/c/astrochannel" style={inp} />
              </div>
              <div>
                <label style={lbl}>Personal Website Link</label>
                <input name="website" value={formData.website} onChange={handleChange} placeholder="e.g. https://www.astrologerdev.com" style={inp} />
              </div>
              <div>
                <label style={lbl}>Facebook / Instagram / Social Page</label>
                <input name="social" value={formData.social} onChange={handleChange} placeholder="e.g. https://instagram.com/astrologerdev" style={inp} />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
                <button type="button" onClick={handleBack} style={btnBack}>← Back</button>
                <button type="submit" style={btnNext}>Next: Payout Details →</button>
              </div>
            </form>
          )}

          {/* ─── STEP 6: Payout Details ─── */}
          {step === 6 && (
            <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>Payout & Tax Information</h2>
                <p style={{ color: '#777', fontSize: '0.78rem', marginBottom: '1rem' }}>Enter individual bank details and PAN for secure payouts.</p>
              </div>
              <div style={{ padding: '0.75rem 1rem', background: 'rgba(255,153,51,0.05)', border: '1px solid rgba(255,153,51,0.15)', borderRadius: '0.5rem' }}>
                <p style={{ color: '#ff9933', fontSize: '0.72rem', margin: 0, lineHeight: 1.4 }}>
                  🔒 Security Compliance: Payout details are encrypted and locked. Payouts are directly routed to this bank account on the 1st of every month.
                </p>
              </div>
              <div>
                <label style={lbl}>Personal PAN Card Number *</label>
                <input name="pan" required value={formData.pan} onChange={handleChange} placeholder="e.g. ABCDE1234F" style={{ ...inp, textTransform: 'uppercase' }} />
              </div>
              <div>
                <label style={lbl}>Individual Bank Account Number *</label>
                <input name="bankAccount" required value={formData.bankAccount} onChange={handleChange} placeholder="Account number" style={inp} />
              </div>
              <div>
                <label style={lbl}>Bank IFSC Code *</label>
                <input name="ifsc" required value={formData.ifsc} onChange={handleChange} placeholder="e.g. SBIN0001234" style={{ ...inp, textTransform: 'uppercase' }} />
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
                <button type="button" onClick={handleBack} style={btnBack}>← Back</button>
                <button type="submit" style={btnNext}>Next: Final Verification →</button>
              </div>
            </form>
          )}

          {/* ─── STEP 7: Final Verification ─── */}
          {step === 7 && (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
              <div>
                <h2 style={{ color: '#fff', fontWeight: 700, fontSize: '1.1rem', marginBottom: '0.2rem' }}>Application Verification</h2>
                <p style={{ color: '#777', fontSize: '0.78rem', marginBottom: '1rem' }}>Provide sample reading link or notes to speed up approval.</p>
              </div>
              <div>
                <label style={lbl}>Sample Audio / Video Reading Link (Optional)</label>
                <input name="sampleReadingUrl" value={formData.sampleReadingUrl} onChange={handleChange} placeholder="Paste link to a recorded video reading (G-Drive / YouTube)" style={inp} />
                <p style={{ color: '#555', fontSize: '0.72rem', marginTop: '0.3rem' }}>Providing a sample helps our senior astrologer panel evaluate your readings faster.</p>
              </div>
              <div style={{ padding: '0.85rem 1rem', background: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.12)', borderRadius: '0.5rem' }}>
                <p style={{ color: '#a0a0a0', fontSize: '0.75rem', margin: 0, lineHeight: 1.4 }}>
                  ✅ By submitting, you consent to background credentials checks and verify that all information entered is accurate. Our acarya panel will schedule your interview within 48 hours.
                </p>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.5rem' }}>
                <button type="button" onClick={handleBack} disabled={loading} style={btnBack}>← Back</button>
                <button type="submit" disabled={loading} style={{ ...btnNext, background: loading ? '#555' : 'linear-gradient(90deg, #E8B84B, #B8923A)', color: '#000', cursor: loading ? 'not-allowed' : 'pointer' }}>
                  {loading ? 'Submitting Application...' : '🙏 Submit Application'}
                </button>
              </div>
            </form>
          )}

        </div>

        <div style={{ textAlign: 'center', marginTop: '1.25rem' }}>
          <a href="/login" style={{ color: '#444', fontSize: '0.78rem', textDecoration: 'none' }}
            onMouseOver={e => e.target.style.color = '#E8B84B'}
            onMouseOut={e => e.target.style.color = '#444'}>
            ← Back to Login
          </a>
        </div>
        <p style={{ textAlign: 'center', marginTop: '0.75rem', color: '#8D8471', fontSize: '0.65rem' }}>Ananda Marga © 2026 — Consultation Portal</p>
      </div>
    </div>
  );
};

export default AcaryaRegister;
